import { defineComponent, ref, openBlock, createElementBlock, createElementVNode, renderSlot, createVNode, withCtx, toDisplayString, unref, createCommentVNode, createTextVNode } from "vue";
import ChevronLeftIcon from "../../assets/icons/chevron-left.svg.js";
import Button from "../button/Button.vue.js";
const _hoisted_1 = {
  key: 0,
  class: "main-layout__header-back-row"
};
const _hoisted_2 = { class: "main-layout__header-back" };
const _hoisted_3 = { class: "main-layout__header-row" };
const _hoisted_4 = { class: "main-layout__header-main" };
const _hoisted_5 = { class: "main-layout__header-title" };
const _hoisted_6 = {
  key: 0,
  class: "main-layout__header-description"
};
const _hoisted_7 = { class: "main-layout__header-actions" };
const _hoisted_8 = {
  key: 1,
  class: "main-layout__header-filters"
};
const _hoisted_9 = {
  key: 2,
  class: "main-layout__header-breadcrumbs"
};
const _hoisted_10 = {
  key: 3,
  class: "main-layout__divider"
};
const _hoisted_11 = { class: "main-layout__content-body" };
const _hoisted_12 = { class: "main-layout__footer-slot" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "MainLayout",
  props: {
    showBack: { type: Boolean, default: false },
    backText: { default: "Back" },
    title: {},
    description: {},
    showHeaderDivider: { type: Boolean, default: true }
  },
  emits: ["back"],
  setup(__props, { expose: __expose, emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const mainLayoutRef = ref(null);
    const headerRef = ref(null);
    const footerRef = ref(null);
    __expose({ mainLayoutRef, headerRef, footerRef });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        ref_key: "mainLayoutRef",
        ref: mainLayoutRef,
        class: "main-layout"
      }, [
        props.showBack || props.title || props.description || _ctx.$slots.back || _ctx.$slots.title || _ctx.$slots.description || _ctx.$slots.actions || _ctx.$slots.filters || _ctx.$slots.breadcrumbs ? (openBlock(), createElementBlock("header", {
          key: 0,
          ref_key: "headerRef",
          ref: headerRef,
          class: "main-layout__header"
        }, [
          props.showBack || _ctx.$slots.back ? (openBlock(), createElementBlock("div", _hoisted_1, [
            createElementVNode("div", _hoisted_2, [
              renderSlot(_ctx.$slots, "back", {}, () => [
                createVNode(Button, {
                  type: "secondary",
                  size: "sm",
                  onClick: _cache[0] || (_cache[0] = ($event) => emit("back"))
                }, {
                  prefix: withCtx(() => [
                    createVNode(unref(ChevronLeftIcon))
                  ]),
                  default: withCtx(() => [
                    createElementVNode("span", null, toDisplayString(props.backText), 1)
                  ]),
                  _: 1
                })
              ], true)
            ])
          ])) : createCommentVNode("", true),
          createElementVNode("div", _hoisted_3, [
            createElementVNode("div", _hoisted_4, [
              createElementVNode("div", _hoisted_5, [
                _cache[1] || (_cache[1] = createElementVNode("div", {
                  id: "elfie-main-layout-title-portal",
                  class: "main-layout__header-portal"
                }, null, -1)),
                renderSlot(_ctx.$slots, "title", {}, () => [
                  createTextVNode(toDisplayString(props.title), 1)
                ], true)
              ]),
              props.description || _ctx.$slots.description ? (openBlock(), createElementBlock("div", _hoisted_6, [
                renderSlot(_ctx.$slots, "description", {}, () => [
                  createTextVNode(toDisplayString(props.description), 1)
                ], true)
              ])) : createCommentVNode("", true)
            ]),
            createElementVNode("div", _hoisted_7, [
              _cache[2] || (_cache[2] = createElementVNode("div", {
                id: "elfie-main-layout-actions-portal",
                class: "main-layout__header-portal"
              }, null, -1)),
              renderSlot(_ctx.$slots, "actions", {}, void 0, true)
            ])
          ]),
          _ctx.$slots.filters ? (openBlock(), createElementBlock("div", _hoisted_8, [
            renderSlot(_ctx.$slots, "filters", {}, void 0, true)
          ])) : createCommentVNode("", true),
          _ctx.$slots.breadcrumbs ? (openBlock(), createElementBlock("div", _hoisted_9, [
            renderSlot(_ctx.$slots, "breadcrumbs", {}, void 0, true)
          ])) : createCommentVNode("", true),
          __props.showHeaderDivider && !_ctx.$slots.breadcrumbs ? (openBlock(), createElementBlock("hr", _hoisted_10)) : createCommentVNode("", true)
        ], 512)) : createCommentVNode("", true),
        createElementVNode("main", _hoisted_11, [
          renderSlot(_ctx.$slots, "default", {}, void 0, true)
        ]),
        _ctx.$slots.footer ? (openBlock(), createElementBlock("footer", {
          key: 1,
          ref_key: "footerRef",
          ref: footerRef,
          class: "main-layout__footer"
        }, [
          _cache[3] || (_cache[3] = createElementVNode("hr", { class: "main-layout__divider" }, null, -1)),
          createElementVNode("div", _hoisted_12, [
            renderSlot(_ctx.$slots, "footer", {}, void 0, true)
          ])
        ], 512)) : createCommentVNode("", true)
      ], 512);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=MainLayout.vue2.js.map
